export default "__VITE_ASSET__oUb7Hw7K__"